import { createFileRoute, redirect } from "@tanstack/react-router";

import { loginSearchSchema } from "@/api/contracts/auth-error-codes";

// Legacy alias: the old stack scoped its sign-in page under a company slug.
// The slug carried no meaning the new app needs — one login page serves both
// audiences — so it is accepted and ignored. Public by design, like /login:
// gating this would send a visitor to the very page they asked for.
//
// The search params are re-parsed here and forwarded so a stale link's
// `?redirect=` still survives the alias; the schema's `.catch(undefined)`
// drops anything malformed rather than failing the navigation.
export const Route = createFileRoute("/$companySlug/login")({
  validateSearch: loginSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/login", search, replace: true });
  },
});
